import { useTranslations } from "../../contexts/Translation";
import { Response } from "../../types";
import { getQuoteName } from "../../lib/getQuoteName";
import CopyValue from "../CopyValue/CopyValue";
import styles from "./SidePanel.module.css";

const QuoteCard = ({ responses }: { responses: Response[] }) => {
  const t = useTranslations("surveys");
  const tQuestions = useTranslations("questions");
  const first = responses.find((r) => !!r.recommendation);
  if (!first?.recommendation) {
    return null;
  }

  return (
    <section className={styles.card} aria-labelledby='quote-heading'>
      <h2 id='quote-heading' className={styles.heading}>
        {tQuestions("recommendationHeading")}
      </h2>
      <p className={styles.tag}>{t("mayQuote")}</p>
      <blockquote className={styles.quote}>
        <p>{first.recommendation}</p>
        <footer>{getQuoteName(first.recommendationName, first.recommendationTitle, first.responder)}</footer>
      </blockquote>
      <CopyValue variant='compact' value={first.recommendation} />
    </section>
  );
};

export default QuoteCard;
